import { ArcwarePixelStreaming } from "../../ArcwarePixelStreaming";
import { AudioIcon } from "./AudioIcon";

export class AudioButton {
  private button: HTMLButtonElement;
  private stream: ArcwarePixelStreaming;
  private audioIcon: AudioIcon;
  private tooltipText: HTMLElement;

  constructor(stream: ArcwarePixelStreaming) {
    this.stream = stream;
    this.setAudioMutedByDefault();
    this.button = this.createButton();
    this.audioIcon = new AudioIcon();
    this.tooltipText = this.createTooltipText();
    this.button.appendChild(this.tooltipText);
    this.button.appendChild(this.audioIcon.audioIconMuted);
    this.button.appendChild(this.audioIcon.audioIconUnmuted);
    this.audioIcon.audioIconUnmuted.style.display = "none";
    this.button.addEventListener("click", this.toggleAudio.bind(this));

    // Bind the onVolumeChange method to the current instance
    this.onVolumeChange = this.onVolumeChange.bind(this);

    const videoElement = this.stream["webRtcController"].videoPlayer["videoElement"];
    videoElement.addEventListener("volumechange", this.onVolumeChange.bind(this));
  }

  private setAudioMutedByDefault(): void {
    const videoElementParent = this.stream.videoElementParent;
    if (videoElementParent) {
      const videoElement = videoElementParent.querySelector("video");
      if (videoElement) {
        this.stream.toggleAudio(videoElement, true);
      }
    }
  }

  private createButton(): HTMLButtonElement {
    const button = document.createElement("button");
    button?.setAttribute("id", "audioBtn");
    button?.setAttribute("type", "button");
    button?.classList?.add("UiTool");
    return button;
  }

  private createTooltipText(): HTMLElement {
    const tooltipText = document.createElement("span");
    tooltipText?.classList?.add("tooltiptext");
    tooltipText.innerHTML = "Mute/Unmute";
    return tooltipText;
  }

  private toggleAudio(): void {
    const videoElementParent = this.stream.videoElementParent;
    if (videoElementParent) {
      const videoElement = videoElementParent.querySelector("video");
      if (videoElement) {
        const muted = !videoElement.muted;
        this.stream.toggleAudio(videoElement, muted);
        this.updateAudioIcon(muted);
      }
    }
  }

  private updateAudioIcon(muted: boolean): void {
    if (muted) {
      this.audioIcon.audioIconUnmuted.style.display = "none";
      this.audioIcon.audioIconMuted.style.display = "block";
    } else {
      this.audioIcon.audioIconMuted.style.display = "none";
      this.audioIcon.audioIconUnmuted.style.display = "block";
    }
  }

  public get element(): HTMLButtonElement {
    return this.button;
  }

  private onVolumeChange(event: Event) {
    const videoElement = event.target as HTMLMediaElement;
    this.updateAudioIcon(videoElement.muted);
  }
}
